"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetTypeToJSON = exports.AssetTypeFromJSONTyped = exports.AssetTypeFromJSON = exports.AssetType = void 0;
/**
 * The type of asset.
 * @export
 */
exports.AssetType = {
    Audio: 'AUDIO',
    Image: 'IMAGE',
    Video: 'VIDEO'
};
function AssetTypeFromJSON(json) {
    return AssetTypeFromJSONTyped(json, false);
}
exports.AssetTypeFromJSON = AssetTypeFromJSON;
function AssetTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AssetTypeFromJSONTyped = AssetTypeFromJSONTyped;
function AssetTypeToJSON(value) {
    return value;
}
exports.AssetTypeToJSON = AssetTypeToJSON;
